import {createTheme, ThemeProvider} from '@mui/material/styles';
import React from 'react';

// A bare MUI default theme, created once at module load.
const defaultTheme = createTheme();

/**
 * Insulates a subtree from the app-wide legacy-wandb-ui MUI theme so its
 * `@mui/*` components render with MUI's own defaults.
 *
 * Context: the app root wraps everything in the legacy-wandb-ui `ThemeProvider`
 * (see App.tsx). Before the MUI v4->v9 upgrade that provider fed a *v4* theme,
 * so already-v9 `@mui/*` components underneath fell through to MUI's default
 * theme. After the upgrade the provider is a *v9* provider, so the converted
 * legacy theme (custom spacing scale, palette, `disableRipple`, component
 * style overrides, ...) now applies to every v9 component app-wide.
 *
 * Regions that were authored against MUI's default theme (the Browse3 subtree
 * plus a few standalone components) regressed as a result. Wrapping them in
 * this provider restores their pre-upgrade appearance. Only the MUI/emotion
 * theme is reset here; the styled-components legacy theme provided higher up
 * (consumed via `p => p.theme...`) is intentionally left untouched.
 */
export const DefaultMuiTheme: React.FC<{children?: React.ReactNode}> = ({
  children,
}) => <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>;
